/* Finish radios enhance the existing variant selector; cart submission stays in wo-purchase.js. */
(function (window, document) {
  'use strict';
  function matchingVariants(variants, selected, index, value) {
    return variants.filter(function (variant) {
      if (variant.options[index] !== value) { return false; }
      for (var i = 0; i < index; i++) { if (variant.options[i] !== selected[i]) { return false; } }
      return true;
    });
  }
  function addVisual(label, choice) {
    var visual = document.createElement('span');
    visual.className = 'wo-swatch-visual';
    visual.setAttribute('aria-hidden', 'true');
    if (choice.image && /^(https?:)?\/\//i.test(choice.image)) {
      var image = document.createElement('img');
      image.src = choice.image;
      image.alt = '';
      image.width = 48;
      image.height = 48;
      image.loading = 'lazy';
      visual.appendChild(image);
    } else if (choice.color) {
      visual.style.backgroundColor = choice.color;
    } else {
      var initial = document.createElement('span');
      initial.className = 'wo-swatch-initial';
      initial.textContent = choice.value.slice(0, 1).toUpperCase();
      visual.appendChild(initial);
    }
    label.appendChild(visual);
  }
  function init(form) {
    if (form.getAttribute('data-wo-swatches-ready') === 'true' || form.getAttribute('data-wo-ready') !== 'true') { return; }
    var data;
    try { data = JSON.parse(form.querySelector('[data-wo-product-json]').textContent); } catch (error) { return; }
    if (!Array.isArray(data.finishSwatches) || !Array.isArray(data.variants)) { return; }
    var groups = [];
    data.finishSwatches.forEach(function (palette) {
      var index = Number(palette.index);
      if (!Number.isInteger(index) || index < 0 || index >= data.options.length || !Array.isArray(palette.values)) { return; }
      var control = form.querySelector('[data-wo-option="' + index + '"]');
      if (!control || !control.parentNode || !palette.values.length) { return; }
      var nativeWrapper = control.parentNode;
      var group = document.createElement('fieldset');
      group.className = 'wo-finish-picker';
      group.setAttribute('data-wo-finish-picker', String(index));
      var legend = document.createElement('legend');
      legend.appendChild(document.createTextNode(palette.name + ': '));
      var current = document.createElement('span');
      current.className = 'wo-finish-current';
      legend.appendChild(current);
      group.appendChild(legend);
      var list = document.createElement('div');
      list.className = 'wo-finish-choices';
      group.appendChild(list);
      var radios = [];
      palette.values.forEach(function (choice, position) {
        if (!choice || typeof choice.value !== 'string') { return; }
        var label = document.createElement('label');
        label.className = 'wo-finish-choice';
        var radio = document.createElement('input');
        radio.type = 'radio';
        radio.name = 'wo_finish_' + data.id + '_' + index;
        radio.value = choice.value;
        radio.id = 'wo-finish-' + data.id + '-' + index + '-' + position;
        label.htmlFor = radio.id;
        label.appendChild(radio);
        addVisual(label, choice);
        var text = document.createElement('span');
        text.className = 'wo-finish-name';
        text.textContent = choice.value;
        label.appendChild(text);
        var availability = document.createElement('span');
        availability.className = 'wo-finish-availability';
        label.appendChild(availability);
        list.appendChild(label);
        radios.push({ radio: radio, label: label, availability: availability });
        radio.addEventListener('change', function () {
          if (!radio.checked || radio.disabled || form.getAttribute('aria-busy') === 'true') { return; }
          control.value = radio.value;
          control.dispatchEvent(new window.Event('change', { bubbles: true }));
          refresh();
        });
      });
      if (!radios.length) { return; }
      nativeWrapper.parentNode.insertBefore(group, nativeWrapper);
      nativeWrapper.setAttribute('data-wo-finish-native', '');
      nativeWrapper.hidden = true;
      groups.push({ index: index, control: control, radios: radios, current: current });
    });
    function refresh() {
      var selected = (data.options || []).map(function (name, index) {
        var control = form.querySelector('[data-wo-option="' + index + '"]');
        return control ? control.value : '';
      });
      var busy = form.getAttribute('aria-busy') === 'true';
      groups.forEach(function (group) {
        var allowed = Array.prototype.map.call(group.control.querySelectorAll('option'), function (option) { return option.value; });
        group.current.textContent = group.control.value;
        group.radios.forEach(function (entry) {
          var value = entry.radio.value;
          var included = allowed.indexOf(value) !== -1;
          var available = matchingVariants(data.variants, selected, group.index, value).some(function (variant) { return variant.available; });
          entry.radio.checked = value === group.control.value;
          entry.radio.disabled = busy || !included;
          entry.label.hidden = !included;
          entry.label.className = 'wo-finish-choice' + (entry.radio.checked ? ' is-selected' : '') + (available ? '' : ' is-unavailable');
          entry.availability.textContent = available ? '' : 'Out of stock';
        });
      });
    }
    form.addEventListener('change', refresh);
    window.addEventListener('variantChange', refresh);
    form.setAttribute('data-wo-swatches-ready', 'true');
    refresh();
  }
  function boot() {
    var forms = document.querySelectorAll('form[data-wo-purchase]');
    for (var i = 0; i < forms.length; i++) { init(forms[i]); }
  }
  window.WheelsOutletFinishSwatches = { init: init, matchingVariants: matchingVariants };
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})(window, document);
